import { jsx } from '@theme-ui/core';
import { css } from '@theme-ui/css';
import { Global as Global$1 } from '@emotion/react';

var Global = function Global(_ref) {
  var _styles = _ref.styles;
  return jsx(Global$1, {
    styles: function styles(emotionTheme) {
      var theme = emotionTheme;
      return css(_styles)(theme);
    }
  });
};

export { Global as default };
